import { faCalendarDays, faGear, faHouseWindow, faInboxFull } from "@fortawesome/pro-solid-svg-icons"
import {
    USER_REPORTS_ARCHIVE_ROUTE,
    USER_REPORTS_CALENDAR_ROUTE,
    USER_REPORTS_ROUTE,
    USER_REPORTS_SETTINGS_ROUTE,
} from "../../../constants/routes"
import { NarrowNavItem } from "../../../shared/layouts/NarrowNavItems"
import { EnvironmentType } from "../../environment/envTypes"

export const userReportingNavItems: NarrowNavItem[] = [
    {
        icon: faHouseWindow,
        label: "Home",
        translationLabel: "user-nav-item-home-label",
        shortLabelKey: "user-nav-bottom-bar-home-label",
        route: USER_REPORTS_ROUTE,
    },
    {
        icon: faCalendarDays,
        label: "Calendar",
        translationLabel: "user-nav-item-calendar-label",
        shortLabelKey: "user-nav-bottom-bar-calendar-label",
        route: USER_REPORTS_CALENDAR_ROUTE,
    },
    {
        icon: faInboxFull,
        label: "Archive",
        translationLabel: "user-nav-item-archive-label",
        shortLabelKey: "user-nav-bottom-bar-archive-label",
        route: USER_REPORTS_ARCHIVE_ROUTE,
    },
    {
        icon: faGear,
        label: "Settings",
        translationLabel: "user-nav-item-settings-label",
        shortLabelKey: "user-nav-bottom-bar-settings-label",
        route: USER_REPORTS_SETTINGS_ROUTE,
        environments: [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo],
    },
]
